module.exports = __webpack_public_path__ + "images/category_lp/common/icon-step2@2x_b1a80ead4ddc320f75a340bfe1ef1227.png";